import { List, Record } from 'immutable'
import { AssociatedContact, IAssociatedContact } from './AssociatedContact'

export interface ICompanyContactsResult {
  resultCount: number
  results: List<IAssociatedContact>
  timestamp: number
}

const CompanyContactsResultRecord = Record({
  count: 0,
  results: List<AssociatedContact>(),
  timestamp: Math.round(new Date().getTime() / 1000),
})

export class CompanyContactsResult extends CompanyContactsResultRecord {
  public static fromJS(initialState?: Partial<ICompanyContactsResult>) {
    if (!initialState) {
      return new CompanyContactsResult()
    }

    const { resultCount, results, timestamp, ...rest } = initialState
    return new CompanyContactsResult({
      ...rest,
    })
  }

  public readonly resultCount: number
  public readonly results: List<AssociatedContact>
  public readonly timestamp: number

  constructor(initialState?: Partial<CompanyContactsResult>) {
    initialState ? super(initialState) : super()
  }
}
